import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '6',
  label: 'Core Teaching Volumes'
}, {
  value: '5',
  label: 'Professional Teacher Bonuses'
}, {
  value: 'K–12',
  label: 'Elementary · Middle · High'
}, {
  value: '⚡',
  label: 'Instant Digital Access'
}];
export function Hero() {
  return <section className="w-full bg-navy px-5 pb-8 pt-6 sm:pb-14 sm:pt-12" data-id="element-101" data-mp="4mrsmw7hjrj4">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-102" data-mp="12a0mbehn46w7">
        <span className="mb-4 inline-block rounded-full border border-gold bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold sm:mb-6" data-id="element-103" data-mp="xae8p3xwgomv">
          For Visual Arts Teachers
        </span>
        <h1 className="font-display text-[24px] font-bold leading-tight text-white sm:text-5xl md:text-6xl" data-id="element-104" data-mp="ncq0pcba9kmr">
          Your Entire Art Year—Organized and Ready to Teach.
        </h1>
        <figure className="relative mt-5 w-full max-w-[760px] sm:mt-8" data-id="element-105" data-mp="382ffxqfwf8fz">
          <img src="https://cdn.magicpatterns.com/uploads/7UQeZ8qb5BT5z1FJDNtiGC/the_complete_art_year_mockup.webp" alt="THE COMPLETE ART YEAR displayed on a desktop screen, tablet and phone alongside the printed core volumes, bonus resources and student worksheets" width="760" height="427" sizes="(max-width: 767px) 100vw, 760px" fetchPriority="high" loading="eager" decoding="sync" className="block aspect-[16/9] w-full object-cover" style={{
          maskImage: 'radial-gradient(120% 115% at 50% 45%, #000 52%, rgba(0,0,0,0.55) 74%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(120% 115% at 50% 45%, #000 52%, rgba(0,0,0,0.55) 74%, transparent 100%)'
        }} data-id="element-106" data-mp="384jt6yzotjsx" />
        </figure>
        <p className="mt-4 max-w-xl text-[13px] leading-relaxed text-white/75 sm:mt-6 sm:text-base" data-id="element-107" data-mp="2qhqvxnkct20i">
          A complete visual teaching system with lessons, activities, creative projects, art history,
          assessment tools and classroom resources—all designed to help you spend less time building
          everything from scratch.
        </p>
        <p className="mt-3 text-[13px] font-semibold text-white sm:mt-4 sm:text-base" data-id="element-108" data-mp="s2bc6ahwz5ay">
          6 Core Teaching Volumes + 5 Professional Teacher Bonuses
        </p>
        <div className="mt-5 w-full max-w-md sm:mt-7" data-id="element-109" data-mp="ic87hd1fk2ws">
          <CTAButton label="GET THE COMPLETE ART YEAR™" data-id="element-110" data-mp="icromrj9an9r" />
          <p className="mt-3 text-xs text-white/65 sm:text-sm" data-id="element-111" data-mp="ddnhs7jt11ml">
            One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
          </p>
          <p className="mt-2 text-xs font-medium text-gold" data-id="element-112" data-mp="1ayjhtfeu9i6s">
            Elementary · Middle School · High School
          </p>
        </div>
        <div className="mt-6 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-gold bg-steel sm:mt-8 sm:grid-cols-4" data-id="element-113" data-mp="111ycsu2tk72y">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-3 py-4 sm:px-4 sm:py-6 ${index % 2 !== 0 ? 'border-l border-gold/45' : ''} ${index >= 2 ? 'border-t border-gold/45' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-114" data-mp="3lsyt309hwojl" data-mpi={index}>
              <span className="font-display text-3xl font-bold text-gold sm:text-4xl" data-id="element-115" data-mp="1xam6ou2m9x0i">{metric.value}</span>
              <span className="mt-1 text-xs font-semibold text-white sm:text-sm" data-id="element-116" data-mp="21bpjt8ta5ey1">
                {metric.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}